(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["casa-octa-assurance-v7"] && !Shopify.designMode) return;
  try {
    class CasaAssuranceV7 extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.panel = this.querySelector('[data-assurance-panel]');
      this.triggers = Array.from(this.querySelectorAll('[data-assurance-trigger]'));
      this.form = this.panel?.querySelector('form');
      if (!this.panel || !this.form || !this.triggers.length) return;

      const result = this.panel.querySelector('[data-assurance-result]');
      const returnedToPanel = [this.panel.id, this.form.id].some(id => location.hash === `#${id}`);
      this.setOpen(Boolean(result || returnedToPanel));
      this.querySelector('[data-assurance-close]').hidden = false;
      this.triggers.forEach(trigger => trigger.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.setOpen(true);
        this.syncContext();
        this.panel.querySelector('h3').focus();
      }, options));
      this.querySelector('[data-assurance-close]').addEventListener('click', () => this.closePanel(), options);
      this.panel.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closePanel();
        }
      }, options);
      window.addEventListener('hashchange', () => {
        if (location.hash === `#${this.panel.id}`) this.setOpen(true);
      }, options);
      document.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.productId) === this.dataset.productId && event.detail?.resource?.id) {
          this.syncContext(event.detail.resource.id);
        }
      }, options);
      this.form.addEventListener('submit', () => this.syncContext(), { ...options, capture: true });
      this.syncContext();
      const dialog = this.querySelector('dialog');
      this.querySelectorAll('[data-crate-photo]').forEach(button => button.addEventListener('click', () => {
        const source = button.querySelector('img');
        const image = dialog.querySelector('img');
        image.src = button.dataset.cratePhoto || source.currentSrc || source.src;
        image.alt = source.alt;
        this.photoTrigger = button;
        dialog.showModal();
      }, options));
      this.querySelector('[data-crate-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => this.photoTrigger?.focus(), options);
      if (result) result.focus();
    }

    setOpen(open) {
      this.panel.hidden = !open;
      this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', String(open)));
    }

    closePanel() {
      this.setOpen(false);
      this.triggers[0].focus();
    }

    syncContext(variantId) {
      const variantInput = this.form.querySelector('[data-assurance-variant]');
      const returnUrl = new URL(location.href);
      const variant = variantId || returnUrl.searchParams.get('variant') || variantInput.value;
      if (variant) returnUrl.searchParams.set('variant', variant);
      returnUrl.searchParams.delete('contact_posted');
      returnUrl.hash = this.panel.id;
      this.form.elements.namedItem('return_to').value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
      variantInput.value = variant;
      const productUrl = new URL(returnUrl.pathname, returnUrl.origin);
      if (variant) productUrl.searchParams.set('variant', variant);
      this.form.querySelector('[data-assurance-product-url]').value = productUrl.href;
    }

    disconnectedCallback() { this.abort?.abort(); }
  }

  if (!customElements.get('casa-assurance-v7')) customElements.define('casa-assurance-v7', CasaAssuranceV7);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["casa-octamirror-layers-v6"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('casa-octa-layers-v6')) {
    customElements.define('casa-octa-layers-v6', class extends HTMLElement {
      connectedCallback() {
        this.cleanup();
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.track = this.querySelector('.casa-octa-layers__track');
        this.sticky = this.querySelector('.casa-octa-layers__sticky');
        this.figure = this.querySelector('.casa-octa-layers__figure');
        this.heading = this.querySelector('.casa-octa-layers__header');
        this.loadStatus = this.querySelector('.casa-octa-layers__load-status');
        this.stage = this.querySelector('.casa-octa-layers__stage');
        this.poster = this.querySelector('.casa-octa-layers__poster');
        this.pieces = [...this.querySelectorAll('[data-piece]')];
        this.pieceGroup = this.querySelector('.casa-octa-layers__pieces');
        this.marker = this.querySelector('.casa-octa-layers__marker');
        this.finale = this.querySelector('.casa-octa-finale');
        this.finaleArt = this.querySelector('.casa-octa-finale__art');
        this.finaleHeading = this.querySelector('.casa-octa-finale__heading');
        this.features = [...this.querySelectorAll('[data-feature]')];
        this.featureMarkers = [...this.querySelectorAll('[data-feature-marker]')];
        this.featureLines = [...this.querySelectorAll('[data-feature-line]')];
        this.finaleActions = this.querySelector('.casa-octa-finale__actions');
        this.assemblyUI = [...this.sticky.children].filter(node => node !== this.figure && node !== this.finale);
        this.detail = this.querySelector('.casa-octa-layers__detail');
        this.index = this.querySelector('[data-selection-index]');
        this.titleCopy = this.querySelector('[data-selection-title]');
        this.bodyCopy = this.querySelector('[data-selection-body]');
        this.allCopy ||= { title: this.titleCopy.textContent, body: this.bodyCopy.textContent };
        this.choices = [...this.querySelectorAll('[data-component]')];
        this.steps = [...this.querySelectorAll('[data-step]')];
        this.partSelect = this.querySelector('[data-part-select]');
        this.modeButton = this.querySelector('[data-mode-toggle]');
        this.allButton = this.querySelector('[data-show-all]');
        this.assembledButton = this.querySelector('[data-show-assembled]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.progress = this.targetProgress = 0;
        this.selected = 0;
        this.manualChoice = false;
        this.manualPart = 0;
        this.lastTick = 0;
        this.ready = this.pieces.every(image => image.complete && image.naturalWidth);
        this.loadFailed = false;
        this.dataset.ready = String(this.ready);
        this.loading = false;
        this.descriptionKey = '';
        this.active = false;
        this.detail.hidden = false;
        this.choices.forEach(button => { button.disabled = false; });
        this.querySelector('.casa-octa-layers__navigation').hidden = false;
        this.querySelector('.casa-octa-layers__actions').hidden = false;
        this.partSelect.addEventListener('change', () => {
          const part = Number(this.partSelect.value);
          if (part) this.choose(part);
        }, { signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-revisit')) {
            this.choose(1);
            this.updateTarget(true);
            (this.viewportWidth < 370 ? this.partSelect : this.steps[0]).focus({ preventScroll: true });
          } else if (button.hasAttribute('data-retry')) {
            this.loadFailed = false;
            this.ensureParts();
          } else if (button === this.modeButton) {
            this.manualChoice = this.dataset.mode === 'scroll';
            this.manualPart = 0;
            this.configure();
            this.scrollIntoView({ block: 'start', behavior: 'instant' });
            this.updateTarget(true);
          } else if (button === this.allButton) this.showManual(0);
          else if (button === this.assembledButton) this.showManual(-1);
          else if (button.dataset.step || button.dataset.component) this.choose(Number(button.dataset.step || button.dataset.component));
        }, { signal });
        window.addEventListener('scroll', () => {
          if (this.dataset.mode !== 'scroll') return;
          // Recheck proximity on input as well as observer callbacks. A restored
          // page must not rely on an earlier observer/visibility notification.
          if (!this.active) this.updateActive();
          if (this.active) this.updateTarget();
        }, { signal, passive: true });
        window.addEventListener('resize', () => this.configure(), { signal, passive: true });
        this.reduced.addEventListener('change', () => {
          const wasActive = this.active;
          this.configure();
          if (wasActive) this.scrollIntoView({ block: 'start', behavior: 'instant' });
        }, { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else { this.updateActive(); this.updateTarget(true); }
        }, { signal });
        window.addEventListener('pageshow', () => { this.configure(); this.updateActive(); }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.figure);
        this.chromeObserver = new ResizeObserver(() => this.configure());
        const watchChrome = () => {
          if (!this.isConnected) return;
          const bar = document.querySelector('casa-sticky-cart');
          if (bar) this.chromeObserver.observe(bar);
        };
        watchChrome();
        customElements.whenDefined('casa-sticky-cart').then(watchChrome);
        this.observer = new IntersectionObserver(entries => {
          this.active = entries[0].isIntersecting;
          this.dataset.active = String(this.active);
          if (this.active) {
            this.ensureParts();
            this.updateTarget(true);
          } else this.stop();
        }, { rootMargin: '1200px 0px' });
        this.observer.observe(this);
        this.configure();
        this.updateActive();
      }
      updateActive() {
        const bounds = this.getBoundingClientRect();
        this.active = bounds.bottom >= -1200 && bounds.top <= innerHeight + 1200;
        this.dataset.active = String(this.active);
        if (this.active) { this.ensureParts(); this.updateTarget(true); }
        else this.stop();
      }
      configure() {
        const width = innerWidth;
        this.viewportHeight = innerHeight;
        this.viewportWidth = width;
        const chrome = getComputedStyle(document.documentElement);
        this.stickyTop = Math.min(150, (parseFloat(chrome.getPropertyValue('--header-group-height')) || 80) + 12);
        this.bottomChrome = parseFloat(chrome.getPropertyValue('--casa-chrome-bottom')) || 0;
        this.availableHeight = Math.max(300, this.viewportHeight - this.stickyTop - this.bottomChrome - 16);
        this.style.setProperty('--assembly-top', `${this.stickyTop}px`);
        this.style.setProperty('--assembly-height', `${this.availableHeight}px`);
        this.dataset.compact = String(this.availableHeight < 570);
        const minimumHeight = width >= 1000 ? 400 : width < 370 ? 490 : 460;
        const allowed = !this.reduced.matches && !navigator.connection?.saveData && !this.loadFailed && this.availableHeight >= minimumHeight;
        this.dataset.fallback = this.loadFailed ? 'images' : this.reduced.matches ? 'reduced-motion' : navigator.connection?.saveData ? 'save-data' : this.availableHeight < minimumHeight ? 'height' : '';
        this.dataset.mode = allowed && !this.manualChoice ? 'scroll' : 'manual';
        const scroll = this.dataset.mode === 'scroll';
        if (scroll && this.finale.parentElement !== this.sticky) this.sticky.append(this.finale);
        else if (!scroll && this.finale.parentElement !== this) this.insertBefore(this.finale, this.querySelector('.casa-octa-layers__endnote'));
        if (scroll && this.availableHeight < 570) {
          if (this.heading.parentElement !== this) this.insertBefore(this.heading, this.track);
        } else if (this.heading.parentElement !== this.sticky) this.sticky.prepend(this.heading);
        this.loadStatus.hidden = !this.loadFailed;
        this.modeButton.hidden = !allowed;
        this.modeButton.textContent = scroll ? this.dataset.manualLabel : this.dataset.scrollLabel;
        this.allButton.hidden = scroll;
        this.assembledButton.hidden = scroll;
        this.querySelector('.casa-octa-layers__hint').hidden = !scroll;
        this.measure();
        if (scroll) this.updateTarget(true);
        else { this.stop(); this.showManual(this.manualPart); }
      }
      measure() {
        if (!this.stage) return;
        const bounds = this.stage.getBoundingClientRect();
        this.artWidth = bounds.width;
        this.artHeight = bounds.height;
        this.heroSize = Math.min(this.artWidth, this.artHeight) * 1.07;
        this.stage.style.setProperty('--piece-size', `${this.heroSize}px`);
        this.pieces.forEach(image => { image.sizes = `${Math.ceil(this.heroSize)}px`; });
        this.poster.style.width = this.poster.style.height = `${this.heroSize}px`;
        this.poster.style.left = this.poster.style.top = '50%';
        this.poster.style.transform = 'translate3d(-50%, -50%, 0)';
        this.measureFinale();
        this.render(this.dataset.mode === 'scroll' ? this.progress : this.manualPart === -1 ? 0 : .5);
      }
      measureFinale() {
        if (this.dataset.mode !== 'scroll') return;
        const box = this.sticky.getBoundingClientRect(), stage = this.stage.getBoundingClientRect();
        const width = box.width, height = box.height;
        const narrow = this.viewportWidth < 1000;
        const headerHeight = this.finaleHeading.getBoundingClientRect().height + (narrow ? 28 : 42);
        this.dataset.finaleCompact = 'false';
        const measureRows = () => [0, 1, 2].map(row => Math.max(...(narrow ? this.features.slice(row * 2, row * 2 + 2) : [this.features[row], this.features[row + 3]]).map(node => node.getBoundingClientRect().height)));
        let rowHeights = measureRows();
        if (!narrow && (this.viewportHeight <= 760 || headerHeight + rowHeights.reduce((sum, height) => sum + height, 0) + 118 > height)) {
          this.dataset.finaleCompact = 'true';
          rowHeights = measureRows();
        }
        const featureHeight = rowHeights.reduce((sum, height) => sum + height, 0) + 32;
        const artTop = headerHeight;
        const artSpace = narrow ? Math.max(Math.min(width * .84, 440), height - headerHeight - featureHeight - 90) : height - headerHeight - 60;
        const artBottom = artTop + artSpace;
        const finalHeight = narrow ? Math.max(height, artBottom + featureHeight + 90) : Math.max(height, headerHeight + featureHeight + 86);
        const desktopGap = Math.max(24, (finalHeight - headerHeight - 70 - rowHeights.reduce((sum, height) => sum + height, 0)) / 2);
        const size = Math.min(width * (narrow ? 1.13 : .57), artSpace * (narrow ? 1.12 : 1.23));
        this.finaleOverflow = Math.ceil(finalHeight - height);
        this.style.setProperty('--finale-overhang', `${this.finaleOverflow}px`);
        this.finale.style.setProperty('--finale-height', `${height + this.finaleOverflow}px`);
        this.finaleGeometry = { width, height: height + this.finaleOverflow, narrow, size, x: width / 2, y: (artTop + artBottom) / 2,
          startX: stage.left - box.left + stage.width / 2, startY: stage.top - box.top + stage.height / 2 };
        this.finale.style.setProperty('--finale-size', `${size}px`);
        const anchors = this.featureMarkers.map(node => [Number(node.dataset.anchorX), Number(node.dataset.anchorY)]);
        this.features.forEach((node, i) => {
          const left = i < 3, row = i % 3;
          const labelWidth = node.getBoundingClientRect().width;
          const inset = Math.max(24, width / 2 - size * .48 - labelWidth - 48);
          const x = narrow ? (i % 2 ? width - 16 - labelWidth : 16) : (left ? inset : width - inset - labelWidth);
          const y = narrow ? artBottom + 20 + rowHeights.slice(0, Math.floor(i / 2)).reduce((sum, height) => sum + height + 16, 0) : headerHeight + rowHeights.slice(0, row).reduce((sum, height) => sum + height + desktopGap, 0);
          node.style.left = `${x}px`; node.style.top = `${y}px`;
          const ax = width / 2 + anchors[i][0] * size, ay = (artTop + artBottom) / 2 + anchors[i][1] * size;
          const lx = narrow ? x + labelWidth / 2 : left ? x + labelWidth + 10 : x - 10;
          const ly = narrow ? y - 13 : y + (this.dataset.finaleCompact === 'true' ? 12 : 20);
          const bendX = left ? ax - 25 : ax + 25;
          const distance = Math.hypot(bendX - ax, ly - ay) || 1;
          const endX = ax + (bendX - ax) / distance * 25;
          const endY = ay + (ly - ay) / distance * 25;
          const path = narrow ? `M ${lx} ${ly} L ${lx} ${ly - 14} L ${ax} ${ay}` : `M ${lx} ${ly} L ${bendX} ${ly} L ${endX} ${endY}`;
          this.featureLines[i].querySelector('path').setAttribute('d', path);
          const dot = this.featureLines[i].querySelector('circle');
          dot.setAttribute('cx', ax); dot.setAttribute('cy', ay);
        });
      }
      get travel() { return Math.max(1, this.track.offsetHeight - this.sticky.offsetHeight - (this.finaleOverflow || 0)); }
      updateTarget(snap = false) {
        if (this.dataset.mode !== 'scroll') return;
        const travel = this.travel;
        this.targetProgress = this.clamp((this.stickyTop - this.track.getBoundingClientRect().top) / travel);
        this.dataset.targetProgress = this.targetProgress.toFixed(5);
        if (snap || this.reduced.matches) {
          this.progress = this.targetProgress;
          this.render(this.progress);
        }
        this.schedule();
      }
      schedule() {
        if (this.raf || document.hidden || !this.active || this.dataset.mode !== 'scroll') return;
        this.raf = requestAnimationFrame(time => this.tick(time));
      }
      tick(time) {
        this.raf = 0;
        if (!this.isConnected || document.hidden || !this.active || this.dataset.mode !== 'scroll') return;
        const dt = this.lastTick ? Math.min(50, time - this.lastTick) : 16.67;
        this.lastTick = time;
        this.progress += (this.targetProgress - this.progress) * (1 - Math.exp(-dt / 80));
        if (Math.abs(this.targetProgress - this.progress) < .00001) this.progress = this.targetProgress;
        this.render(this.progress);
        if (this.progress !== this.targetProgress) this.schedule();
        else this.lastTick = 0;
      }
      stop() { cancelAnimationFrame(this.raf); this.raf = 0; this.lastTick = 0; }
      clamp(value) { return Math.max(0, Math.min(1, value)); }
      ease(a, b, value) { const t = this.clamp((value - a) / (b - a)); return t * t * (3 - 2 * t); }
      render(p) {
        const w = this.artWidth, h = this.artHeight;
        if (!w || !h) return;
        const scrolling = this.dataset.mode === 'scroll';
        const assemblyProgress = scrolling ? this.clamp(p / .72) : p;
        const finaleProgress = p;
        p = assemblyProgress;
        const spread = this.ease(0, .22, p) * (1 - this.ease(.79, 1, p));
        const part = scrolling ? (p >= .23 && p < .79 ? Math.min(7, Math.floor((p - .23) / .08) + 1) : 0) : Math.max(0, this.manualPart);
        this.dataset.progress = finaleProgress.toFixed(5);
        this.dataset.view = spread < .001 ? 'assembled' : spread > .98 ? 'exploded' : p < .5 ? 'opening' : 'closing';
        this.describe(part, scrolling ? (p > .79 ? 'end' : 'start') : this.manualPart === -1 ? 'start' : 'all');
        const heroSize = this.heroSize;
        const visibility = this.ready ? this.ease(.012, .20, spread) : 0;
        this.poster.style.opacity = String(1 - visibility);
        this.pieceGroup.style.opacity = String(visibility);
        const drift = Math.sin((p - .5) * Math.PI);
        const attention = scrolling ? this.ease(.20, .26, p) * (1 - this.ease(.77, .81, p)) : Number(this.manualPart > 0);
        for (let i = 0; i < 7; i++) {
          const u = (i - 3) / 3;
          const focus = scrolling ? Math.exp(-Math.pow((p - (.23 + (i + .5) * .08)) / .047, 2)) : Number(this.manualPart === i + 1);
          const overviewX = u * w * .20 + Math.sin(u * Math.PI) * w * .025;
          const overviewY = u * h * .18;
          const stackX = w * (.12 + u * .17 + Math.sin(u * Math.PI) * .035 + drift * .015);
          const stackY = h * (-.13 + u * .17 + drift * .012);
          const orbitX = overviewX + (stackX - overviewX) * attention;
          const orbitY = overviewY + (stackY - overviewY) * attention;
          const x = (orbitX + (-w * .13 - orbitX) * focus) * spread;
          const y = (orbitY + (h * .10 - orbitY) * focus) * spread;
          const overviewSize = Math.min(w * .70, h * .66);
          const smallSize = overviewSize + (Math.min(w * .40, h * .40) - overviewSize) * attention;
          const featuredSize = Math.min(w * .88, h * .94);
          const size = heroSize + (smallSize + (featuredSize - smallSize) * focus - heroSize) * spread;
          const scale = size / heroSize;
          const rotation = drift * .6 * (1 - focus) * spread;
          this.pieces[i].style.opacity = String(1 - attention * (1 - focus) * .28);
          this.pieces[i].style.zIndex = String(Math.round(focus * 100) + 7 - i);
          this.pieces[i].style.transform = `translate3d(calc(-50% + ${x.toFixed(3)}px), calc(-50% + ${y.toFixed(3)}px), 0) rotate(${rotation.toFixed(3)}deg) scale(${scale.toFixed(5)})`;
          if (part === i + 1 && this.ready) {
            const radians = rotation * Math.PI / 180;
            const edgeX = size * .30, edgeY = size * .22;
            const markerX = w / 2 + x + edgeX * Math.cos(radians) - edgeY * Math.sin(radians) - 15;
            const markerY = h / 2 + y + edgeX * Math.sin(radians) + edgeY * Math.cos(radians) - 15;
            this.marker.style.transform = `translate3d(${markerX.toFixed(3)}px, ${markerY.toFixed(3)}px, 0)`;
          }
        }
        this.marker.hidden = !(this.ready && visibility > .98 && part);
        this.marker.textContent = String(part);
        this.renderFinale(finaleProgress);
      }
      renderFinale(p) {
        const scroll = this.dataset.mode === 'scroll';
        const enter = scroll ? this.ease(.72, .776, p) : 0;
        const active = scroll && p > .73;
        this.dataset.finale = String(active);
        this.finale.inert = scroll && !active;
        this.finale.setAttribute('aria-hidden', String(scroll && !active));
        this.finale.style.opacity = scroll ? String(enter > 0 ? 1 : 0) : '';
        this.finaleActions.style.opacity = scroll ? String(enter) : '';
        this.assemblyUI.forEach(node => {
          node.style.opacity = scroll ? String(1 - enter) : '';
          node.inert = active;
          node.setAttribute('aria-hidden', String(active));
        });
        this.finaleArt.style.opacity = this.poster.style.opacity;
        if (enter > 0) this.poster.style.opacity = '0';
        this.finaleHeading.style.opacity = scroll ? String(this.ease(.758, .782, p)) : '';
        this.finaleActions.inert = !active;
        if (!scroll) {
          this.features.forEach((node, i) => {
            node.style.opacity = ''; node.style.transform = ''; node.style.left = ''; node.style.top = '';
            node.removeAttribute('aria-hidden'); this.featureLines[i].style.opacity = ''; this.featureMarkers[i].style.opacity = '';
          });
          this.finaleArt.style.transform = '';
          this.finaleArt.style.opacity = '';
          return;
        }
        const g = this.finaleGeometry;
        if (!g) return;
        const x = g.startX + (g.x - g.startX) * enter;
        const y = g.startY + (g.y - g.startY) * enter;
        const size = this.heroSize + (g.size - this.heroSize) * enter;
        this.finaleArt.style.transform = `translate3d(${x - g.size / 2}px, ${y - g.size / 2}px, 0) scale(${size / g.size})`;
        this.features.forEach((node, i) => {
          const show = this.ease(.779, .804, p);
          const opacity = show;
          node.style.opacity = String(opacity);
          this.featureMarkers[i].style.opacity = String(opacity);
          node.style.transform = `translate3d(0, ${(1 - show) * 8}px, 0)`;
          node.setAttribute('aria-hidden', String(opacity < .05));
          this.featureLines[i].style.opacity = String(opacity * this.ease(.77, .79, p));
        });
      }
      describe(part, state) {
        const key = `${part}:${state}`;
        if (key === this.descriptionKey) return;
        this.descriptionKey = key;
        this.selected = part;
        this.partSelect.value = String(part);
        this.steps.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.step) === part)));
        this.choices.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.component) === part)));
        this.index.textContent = part ? `${String(part).padStart(2, '0')} / 07` : '01–07';
        this.titleCopy.textContent = part ? this.choices[part - 1].querySelector('[data-component-name]').textContent : state === 'all' ? this.allCopy.title : this.dataset[`${state}Title`];
        this.bodyCopy.textContent = part ? this.choices[part - 1].nextElementSibling.textContent : state === 'all' ? this.allCopy.body : this.dataset[`${state}Body`];
      }
      choose(part) {
        this.ensureParts();
        if (this.dataset.mode !== 'scroll') { this.showManual(part); return; }
        const travel = this.travel;
        window.scrollTo({ top: this.track.getBoundingClientRect().top + scrollY - this.stickyTop + (.23 + (part - .5) * .08) * .72 * travel, behavior: 'instant' });
        this.updateTarget();
      }
      showManual(part) {
        this.manualPart = part;
        this.render(part === -1 ? 0 : .5);
        if (part === -1) this.bodyCopy.textContent = this.dataset.endBody;
        if (part > 0) {
          this.ensureParts();
          const bounds = this.stage.getBoundingClientRect();
          if (bounds.top < this.stickyTop || bounds.bottom > innerHeight - this.bottomChrome) this.stage.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      }
      ensureParts() {
        if (this.loading || this.ready || this.loadFailed) return;
        this.loading = true;
        const signal = this.abort.signal;
        Promise.all(this.pieces.map(image => this.loadPart(image, signal))).then(() => {
          if (signal.aborted || !this.isConnected) return;
          this.ready = true;
          this.loadFailed = false;
          this.dataset.ready = 'true';
          this.configure();
        }).catch(() => {
          if (signal.aborted || !this.isConnected) return;
          const returnToView = this.active;
          this.loadFailed = true;
          this.configure();
          if (returnToView) this.scrollIntoView({ block: 'start', behavior: 'instant' });
        }).finally(() => { if (!signal.aborted) this.loading = false; });
      }
      loadPart(image, signal) {
        if (image.complete && image.naturalWidth) return Promise.resolve();
        return new Promise((resolve, reject) => {
          let retried = false;
          const clear = () => {
            image.removeEventListener('load', loaded);
            image.removeEventListener('error', failed);
            signal.removeEventListener('abort', aborted);
          };
          const loaded = () => {
            if (!image.naturalWidth) return;
            clear();
            resolve();
          };
          const failed = () => {
            if (!retried) {
              retried = true;
              image.removeAttribute('srcset');
              image.src = image.dataset.small;
            } else { clear(); reject(new Error('Component image unavailable')); }
          };
          const aborted = () => { clear(); reject(new DOMException('Aborted', 'AbortError')); };
          image.addEventListener('load', loaded);
          image.addEventListener('error', failed);
          signal.addEventListener('abort', aborted, { once: true });
          image.srcset = `${image.dataset.small} 800w, ${image.dataset.src} 1600w`;
          image.src = image.dataset.small;
          // Responsive source reselection can abort decode() without a failed
          // image. Only an actual load/error result determines availability.
          if (image.complete && image.naturalWidth) loaded();
        });
      }
      cleanup() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.chromeObserver?.disconnect();
        this.stop();
      }
      disconnectedCallback() { this.cleanup(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["casa-octamirror-layers-v7"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('casa-octa-layers-v7')) {
    customElements.define('casa-octa-layers-v7', class extends HTMLElement {
      connectedCallback() {
        this.cleanup();
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.track = this.querySelector('.casa-octa-build-v7__track');
        this.sticky = this.querySelector('.casa-octa-build-v7__sticky');
        this.figure = this.querySelector('.casa-octa-build-v7__figure');
        this.heading = this.querySelector('.casa-octa-build-v7__header');
        this.loadStatus = this.querySelector('.casa-octa-build-v7__load-status');
        this.stage = this.querySelector('.casa-octa-build-v7__stage');
        this.poster = this.querySelector('.casa-octa-build-v7__poster');
        this.pieces = [...this.querySelectorAll('[data-piece]')];
        this.pieceGroup = this.querySelector('.casa-octa-build-v7__pieces');
        this.marker = this.querySelector('.casa-octa-build-v7__marker');
        this.finale = this.querySelector('.casa-octa-finale-v7');
        this.finaleArt = this.querySelector('.casa-octa-finale-v7__art');
        this.finaleHeading = this.querySelector('.casa-octa-finale-v7__heading');
        this.features = [...this.querySelectorAll('[data-feature]')];
        this.featureMarkers = [...this.querySelectorAll('[data-feature-marker]')];
        this.featureLines = [...this.querySelectorAll('[data-feature-line]')];
        this.finaleActions = this.querySelector('.casa-octa-finale-v7__actions');
        this.assemblyUI = [...this.sticky.children].filter(node => node !== this.figure && node !== this.finale);
        this.detail = this.querySelector('.casa-octa-build-v7__detail');
        this.index = this.querySelector('[data-selection-index]');
        this.titleCopy = this.querySelector('[data-selection-title]');
        this.bodyCopy = this.querySelector('[data-selection-body]');
        this.allCopy ||= { title: this.titleCopy.textContent, body: this.bodyCopy.textContent };
        this.choices = [...this.querySelectorAll('[data-component]')];
        this.steps = [...this.querySelectorAll('[data-step]')];
        this.partSelect = this.querySelector('[data-part-select]');
        this.modeButton = this.querySelector('[data-mode-toggle]');
        this.allButton = this.querySelector('[data-show-all]');
        this.assembledButton = this.querySelector('[data-show-assembled]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.progress = this.targetProgress = 0;
        this.selected = 0;
        this.manualChoice = false;
        this.manualPart = 0;
        this.lastTick = 0;
        this.ready = this.pieces.every(image => image.complete && image.naturalWidth);
        this.loadFailed = false;
        this.dataset.ready = String(this.ready);
        this.loading = false;
        this.descriptionKey = '';
        this.active = false;
        this.detail.hidden = false;
        this.choices.forEach(button => { button.disabled = false; });
        this.querySelector('.casa-octa-build-v7__navigation').hidden = false;
        this.querySelector('.casa-octa-build-v7__actions').hidden = false;
        this.partSelect.addEventListener('change', () => {
          const part = Number(this.partSelect.value);
          if (part) this.choose(part);
        }, { signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-revisit')) {
            this.choose(1);
            this.updateTarget(true);
            (this.viewportWidth < 370 ? this.partSelect : this.steps[0]).focus({ preventScroll: true });
          } else if (button.hasAttribute('data-retry')) {
            this.loadFailed = false;
            this.ensureParts();
          } else if (button === this.modeButton) {
            this.manualChoice = this.dataset.mode === 'scroll';
            this.manualPart = 0;
            this.configure();
            this.scrollIntoView({ block: 'start', behavior: 'instant' });
            this.updateTarget(true);
          } else if (button === this.allButton) this.showManual(0);
          else if (button === this.assembledButton) this.showManual(-1);
          else if (button.dataset.step || button.dataset.component) this.choose(Number(button.dataset.step || button.dataset.component));
        }, { signal });
        window.addEventListener('scroll', () => {
          if (this.dataset.mode !== 'scroll') return;
          // Recheck proximity on input as well as observer callbacks. A restored
          // page must not rely on an earlier observer/visibility notification.
          if (!this.active) this.updateActive();
          if (this.active) this.updateTarget();
        }, { signal, passive: true });
        window.addEventListener('resize', () => this.configure(), { signal, passive: true });
        this.reduced.addEventListener('change', () => {
          const wasActive = this.active;
          this.configure();
          if (wasActive) this.scrollIntoView({ block: 'start', behavior: 'instant' });
        }, { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else { this.updateActive(); this.updateTarget(true); }
        }, { signal });
        window.addEventListener('pageshow', () => { this.configure(); this.updateActive(); }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.figure);
        this.chromeObserver = new ResizeObserver(() => this.configure());
        const watchChrome = () => {
          if (!this.isConnected) return;
          const bar = document.querySelector('casa-sticky-cart');
          if (bar) this.chromeObserver.observe(bar);
        };
        watchChrome();
        customElements.whenDefined('casa-sticky-cart').then(watchChrome);
        this.observer = new IntersectionObserver(entries => {
          this.active = entries[0].isIntersecting;
          this.dataset.active = String(this.active);
          if (this.active) {
            this.ensureParts();
            this.updateTarget(true);
          } else this.stop();
        }, { rootMargin: '1200px 0px' });
        this.observer.observe(this);
        this.configure();
        this.updateActive();
      }
      updateActive() {
        const bounds = this.getBoundingClientRect();
        this.active = bounds.bottom >= -1200 && bounds.top <= innerHeight + 1200;
        this.dataset.active = String(this.active);
        if (this.active) { this.ensureParts(); this.updateTarget(true); }
        else this.stop();
      }
      configure() {
        const width = innerWidth;
        this.viewportHeight = innerHeight;
        this.viewportWidth = width;
        const chrome = getComputedStyle(document.documentElement);
        this.stickyTop = Math.min(150, (parseFloat(chrome.getPropertyValue('--header-group-height')) || 80) + 12);
        this.bottomChrome = parseFloat(chrome.getPropertyValue('--casa-chrome-bottom')) || 0;
        this.availableHeight = Math.max(300, this.viewportHeight - this.stickyTop - this.bottomChrome - 16);
        this.style.setProperty('--assembly-top', `${this.stickyTop}px`);
        this.style.setProperty('--assembly-height', `${this.availableHeight}px`);
        this.dataset.compact = String(this.availableHeight < 570);
        const minimumHeight = width >= 1000 ? 400 : width < 370 ? 490 : 460;
        const allowed = !this.reduced.matches && !navigator.connection?.saveData && !this.loadFailed && this.availableHeight >= minimumHeight;
        this.dataset.fallback = this.loadFailed ? 'images' : this.reduced.matches ? 'reduced-motion' : navigator.connection?.saveData ? 'save-data' : this.availableHeight < minimumHeight ? 'height' : '';
        this.dataset.mode = allowed && !this.manualChoice ? 'scroll' : 'manual';
        const scroll = this.dataset.mode === 'scroll';
        if (scroll && this.finale.parentElement !== this.sticky) this.sticky.append(this.finale);
        else if (!scroll && this.finale.parentElement !== this) this.insertBefore(this.finale, this.querySelector('.casa-octa-build-v7__endnote'));
        if (scroll && this.availableHeight < 570) {
          if (this.heading.parentElement !== this) this.insertBefore(this.heading, this.track);
        } else if (this.heading.parentElement !== this.sticky) this.sticky.prepend(this.heading);
        this.loadStatus.hidden = !this.loadFailed;
        this.modeButton.hidden = !allowed;
        this.modeButton.textContent = scroll ? this.dataset.manualLabel : this.dataset.scrollLabel;
        this.allButton.hidden = scroll;
        this.assembledButton.hidden = scroll;
        this.querySelector('.casa-octa-build-v7__hint').hidden = !scroll;
        this.measure();
        if (scroll) this.updateTarget(true);
        else { this.stop(); this.showManual(this.manualPart); }
      }
      measure() {
        if (!this.stage) return;
        const bounds = this.stage.getBoundingClientRect();
        this.artWidth = bounds.width;
        this.artHeight = bounds.height;
        this.heroSize = Math.min(this.artWidth, this.artHeight) * 1.07;
        this.stage.style.setProperty('--piece-size', `${this.heroSize}px`);
        this.pieces.forEach(image => { image.sizes = `${Math.ceil(this.heroSize)}px`; });
        this.poster.style.width = this.poster.style.height = `${this.heroSize}px`;
        this.poster.style.left = this.poster.style.top = '50%';
        this.poster.style.transform = 'translate3d(-50%, -50%, 0)';
        this.measureFinale();
        this.render(this.dataset.mode === 'scroll' ? this.progress : this.manualPart === -1 ? 0 : .5);
      }
      measureFinale() {
        if (this.dataset.mode !== 'scroll') return;
        const box = this.sticky.getBoundingClientRect(), stage = this.stage.getBoundingClientRect();
        const width = box.width, height = box.height;
        const narrow = this.viewportWidth < 1000;
        const headerHeight = this.finaleHeading.getBoundingClientRect().height + (narrow ? 28 : 42);
        this.dataset.finaleCompact = 'false';
        const measureRows = () => [0, 1, 2].map(row => Math.max(...(narrow ? this.features.slice(row * 2, row * 2 + 2) : [this.features[row], this.features[row + 3]]).map(node => node.getBoundingClientRect().height)));
        let rowHeights = measureRows();
        if (!narrow && (this.viewportHeight <= 760 || headerHeight + rowHeights.reduce((sum, height) => sum + height, 0) + 118 > height)) {
          this.dataset.finaleCompact = 'true';
          rowHeights = measureRows();
        }
        const featureHeight = rowHeights.reduce((sum, height) => sum + height, 0) + 32;
        const artTop = headerHeight;
        const artSpace = narrow ? Math.max(Math.min(width * .84, 440), height - headerHeight - featureHeight - 90) : height - headerHeight - 60;
        const artBottom = artTop + artSpace;
        const finalHeight = narrow ? Math.max(height, artBottom + featureHeight + 90) : Math.max(height, headerHeight + featureHeight + 86);
        const desktopGap = Math.max(24, (finalHeight - headerHeight - 70 - rowHeights.reduce((sum, height) => sum + height, 0)) / 2);
        const size = Math.min(width * (narrow ? 1.13 : .57), artSpace * (narrow ? 1.12 : 1.23));
        this.finaleOverflow = Math.ceil(finalHeight - height);
        this.style.setProperty('--finale-overhang', `${this.finaleOverflow}px`);
        this.finale.style.setProperty('--finale-height', `${height + this.finaleOverflow}px`);
        this.finaleGeometry = { width, height: height + this.finaleOverflow, narrow, size, x: width / 2, y: (artTop + artBottom) / 2,
          startX: stage.left - box.left + stage.width / 2, startY: stage.top - box.top + stage.height / 2 };
        this.finale.style.setProperty('--finale-size', `${size}px`);
        const anchors = this.featureMarkers.map(node => [Number(node.dataset.anchorX), Number(node.dataset.anchorY)]);
        this.features.forEach((node, i) => {
          const left = i < 3, row = i % 3;
          const labelWidth = node.getBoundingClientRect().width;
          const inset = Math.max(24, width / 2 - size * .48 - labelWidth - 48);
          const x = narrow ? (i % 2 ? width - 16 - labelWidth : 16) : (left ? inset : width - inset - labelWidth);
          const y = narrow ? artBottom + 20 + rowHeights.slice(0, Math.floor(i / 2)).reduce((sum, height) => sum + height + 16, 0) : headerHeight + rowHeights.slice(0, row).reduce((sum, height) => sum + height + desktopGap, 0);
          node.style.left = `${x}px`; node.style.top = `${y}px`;
          const ax = width / 2 + anchors[i][0] * size, ay = (artTop + artBottom) / 2 + anchors[i][1] * size;
          const lx = narrow ? x + labelWidth / 2 : left ? x + labelWidth + 10 : x - 10;
          const ly = narrow ? y - 13 : y + (this.dataset.finaleCompact === 'true' ? 12 : 20);
          const bendX = left ? ax - 25 : ax + 25;
          const distance = Math.hypot(bendX - ax, ly - ay) || 1;
          const endX = ax + (bendX - ax) / distance * 25;
          const endY = ay + (ly - ay) / distance * 25;
          const path = narrow ? `M ${lx} ${ly} L ${lx} ${ly - 14} L ${ax} ${ay}` : `M ${lx} ${ly} L ${bendX} ${ly} L ${endX} ${endY}`;
          this.featureLines[i].querySelector('path').setAttribute('d', path);
          const dot = this.featureLines[i].querySelector('circle');
          dot.setAttribute('cx', ax); dot.setAttribute('cy', ay);
        });
      }
      get travel() { return Math.max(1, this.track.offsetHeight - this.sticky.offsetHeight - (this.finaleOverflow || 0)); }
      updateTarget(snap = false) {
        if (this.dataset.mode !== 'scroll') return;
        const travel = this.travel;
        this.targetProgress = this.clamp((this.stickyTop - this.track.getBoundingClientRect().top) / travel);
        this.dataset.targetProgress = this.targetProgress.toFixed(5);
        if (snap || this.reduced.matches) {
          this.progress = this.targetProgress;
          this.render(this.progress);
        }
        this.schedule();
      }
      schedule() {
        if (this.raf || document.hidden || !this.active || this.dataset.mode !== 'scroll') return;
        this.raf = requestAnimationFrame(time => this.tick(time));
      }
      tick(time) {
        this.raf = 0;
        if (!this.isConnected || document.hidden || !this.active || this.dataset.mode !== 'scroll') return;
        const dt = this.lastTick ? Math.min(50, time - this.lastTick) : 16.67;
        this.lastTick = time;
        this.progress += (this.targetProgress - this.progress) * (1 - Math.exp(-dt / 80));
        if (Math.abs(this.targetProgress - this.progress) < .00001) this.progress = this.targetProgress;
        this.render(this.progress);
        if (this.progress !== this.targetProgress) this.schedule();
        else this.lastTick = 0;
      }
      stop() { cancelAnimationFrame(this.raf); this.raf = 0; this.lastTick = 0; }
      clamp(value) { return Math.max(0, Math.min(1, value)); }
      ease(a, b, value) { const t = this.clamp((value - a) / (b - a)); return t * t * (3 - 2 * t); }
      render(p) {
        const w = this.artWidth, h = this.artHeight;
        if (!w || !h) return;
        const scrolling = this.dataset.mode === 'scroll';
        const assemblyProgress = scrolling ? this.clamp(p / .72) : p;
        const finaleProgress = p;
        p = assemblyProgress;
        const spread = this.ease(0, .22, p) * (1 - this.ease(.79, 1, p));
        const part = scrolling ? (p >= .23 && p < .79 ? Math.min(7, Math.floor((p - .23) / .08) + 1) : 0) : Math.max(0, this.manualPart);
        this.dataset.progress = finaleProgress.toFixed(5);
        this.dataset.view = spread < .001 ? 'assembled' : spread > .98 ? 'exploded' : p < .5 ? 'opening' : 'closing';
        this.describe(part, scrolling ? (p > .79 ? 'end' : 'start') : this.manualPart === -1 ? 'start' : 'all');
        const heroSize = this.heroSize;
        const visibility = this.ready ? this.ease(.012, .20, spread) : 0;
        this.poster.style.opacity = String(1 - visibility);
        this.pieceGroup.style.opacity = String(visibility);
        const drift = Math.sin((p - .5) * Math.PI);
        const attention = scrolling ? this.ease(.20, .26, p) * (1 - this.ease(.77, .81, p)) : Number(this.manualPart > 0);
        for (let i = 0; i < 7; i++) {
          const u = (i - 3) / 3;
          const focus = scrolling ? Math.exp(-Math.pow((p - (.23 + (i + .5) * .08)) / .047, 2)) : Number(this.manualPart === i + 1);
          const overviewX = u * w * .20 + Math.sin(u * Math.PI) * w * .025;
          const overviewY = u * h * .18;
          const stackX = w * (.12 + u * .17 + Math.sin(u * Math.PI) * .035 + drift * .015);
          const stackY = h * (-.13 + u * .17 + drift * .012);
          const orbitX = overviewX + (stackX - overviewX) * attention;
          const orbitY = overviewY + (stackY - overviewY) * attention;
          const x = (orbitX + (-w * .13 - orbitX) * focus) * spread;
          const y = (orbitY + (h * .10 - orbitY) * focus) * spread;
          const overviewSize = Math.min(w * .70, h * .66);
          const smallSize = overviewSize + (Math.min(w * .40, h * .40) - overviewSize) * attention;
          const featuredSize = Math.min(w * .88, h * .94);
          const size = heroSize + (smallSize + (featuredSize - smallSize) * focus - heroSize) * spread;
          const scale = size / heroSize;
          const rotation = drift * .6 * (1 - focus) * spread;
          this.pieces[i].style.opacity = String(1 - attention * (1 - focus) * .28);
          this.pieces[i].style.zIndex = String(Math.round(focus * 100) + 7 - i);
          this.pieces[i].style.transform = `translate3d(calc(-50% + ${x.toFixed(3)}px), calc(-50% + ${y.toFixed(3)}px), 0) rotate(${rotation.toFixed(3)}deg) scale(${scale.toFixed(5)})`;
          if (part === i + 1 && this.ready) {
            const radians = rotation * Math.PI / 180;
            const edgeX = size * .30, edgeY = size * .22;
            const markerX = w / 2 + x + edgeX * Math.cos(radians) - edgeY * Math.sin(radians) - 15;
            const markerY = h / 2 + y + edgeX * Math.sin(radians) + edgeY * Math.cos(radians) - 15;
            this.marker.style.transform = `translate3d(${markerX.toFixed(3)}px, ${markerY.toFixed(3)}px, 0)`;
          }
        }
        this.marker.hidden = !(this.ready && visibility > .98 && part);
        this.marker.textContent = String(part);
        this.renderFinale(finaleProgress);
      }
      renderFinale(p) {
        const scroll = this.dataset.mode === 'scroll';
        const enter = scroll ? this.ease(.72, .776, p) : 0;
        const active = scroll && p > .73;
        this.dataset.finale = String(active);
        this.finale.inert = scroll && !active;
        this.finale.setAttribute('aria-hidden', String(scroll && !active));
        this.finale.style.opacity = scroll ? String(enter > 0 ? 1 : 0) : '';
        this.finaleActions.style.opacity = scroll ? String(enter) : '';
        this.assemblyUI.forEach(node => {
          node.style.opacity = scroll ? String(1 - enter) : '';
          node.inert = active;
          node.setAttribute('aria-hidden', String(active));
        });
        this.finaleArt.style.opacity = this.poster.style.opacity;
        if (enter > 0) this.poster.style.opacity = '0';
        this.finaleHeading.style.opacity = scroll ? String(this.ease(.758, .782, p)) : '';
        this.finaleActions.inert = !active;
        if (!scroll) {
          this.features.forEach((node, i) => {
            node.style.opacity = ''; node.style.transform = ''; node.style.left = ''; node.style.top = '';
            node.removeAttribute('aria-hidden'); this.featureLines[i].style.opacity = ''; this.featureMarkers[i].style.opacity = '';
          });
          this.finaleArt.style.transform = '';
          this.finaleArt.style.opacity = '';
          return;
        }
        const g = this.finaleGeometry;
        if (!g) return;
        const x = g.startX + (g.x - g.startX) * enter;
        const y = g.startY + (g.y - g.startY) * enter;
        const size = this.heroSize + (g.size - this.heroSize) * enter;
        this.finaleArt.style.transform = `translate3d(${x - g.size / 2}px, ${y - g.size / 2}px, 0) scale(${size / g.size})`;
        this.features.forEach((node, i) => {
          const show = this.ease(.779, .804, p);
          const opacity = show;
          node.style.opacity = String(opacity);
          this.featureMarkers[i].style.opacity = String(opacity);
          node.style.transform = `translate3d(0, ${(1 - show) * 8}px, 0)`;
          node.setAttribute('aria-hidden', String(opacity < .05));
          this.featureLines[i].style.opacity = String(opacity * this.ease(.77, .79, p));
        });
      }
      describe(part, state) {
        const key = `${part}:${state}`;
        if (key === this.descriptionKey) return;
        this.descriptionKey = key;
        this.selected = part;
        this.partSelect.value = String(part);
        this.steps.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.step) === part)));
        this.choices.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.component) === part)));
        this.index.textContent = part ? `${String(part).padStart(2, '0')} / 07` : '01–07';
        this.titleCopy.textContent = part ? this.choices[part - 1].querySelector('[data-component-name]').textContent : state === 'all' ? this.allCopy.title : this.dataset[`${state}Title`];
        this.bodyCopy.textContent = part ? this.choices[part - 1].nextElementSibling.textContent : state === 'all' ? this.allCopy.body : this.dataset[`${state}Body`];
      }
      choose(part) {
        this.ensureParts();
        if (this.dataset.mode !== 'scroll') { this.showManual(part); return; }
        const travel = this.travel;
        window.scrollTo({ top: this.track.getBoundingClientRect().top + scrollY - this.stickyTop + (.23 + (part - .5) * .08) * .72 * travel, behavior: 'instant' });
        this.updateTarget();
      }
      showManual(part) {
        this.manualPart = part;
        this.render(part === -1 ? 0 : .5);
        if (part === -1) this.bodyCopy.textContent = this.dataset.endBody;
        if (part > 0) {
          this.ensureParts();
          const bounds = this.stage.getBoundingClientRect();
          if (bounds.top < this.stickyTop || bounds.bottom > innerHeight - this.bottomChrome) this.stage.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      }
      ensureParts() {
        if (this.loading || this.ready || this.loadFailed) return;
        this.loading = true;
        const signal = this.abort.signal;
        Promise.all(this.pieces.map(image => this.loadPart(image, signal))).then(() => {
          if (signal.aborted || !this.isConnected) return;
          this.ready = true;
          this.loadFailed = false;
          this.dataset.ready = 'true';
          this.configure();
        }).catch(() => {
          if (signal.aborted || !this.isConnected) return;
          const returnToView = this.active;
          this.loadFailed = true;
          this.configure();
          if (returnToView) this.scrollIntoView({ block: 'start', behavior: 'instant' });
        }).finally(() => { if (!signal.aborted) this.loading = false; });
      }
      loadPart(image, signal) {
        if (image.complete && image.naturalWidth) return Promise.resolve();
        return new Promise((resolve, reject) => {
          let retried = false;
          const clear = () => {
            image.removeEventListener('load', loaded);
            image.removeEventListener('error', failed);
            signal.removeEventListener('abort', aborted);
          };
          const loaded = () => {
            if (!image.naturalWidth) return;
            clear();
            resolve();
          };
          const failed = () => {
            if (!retried) {
              retried = true;
              image.removeAttribute('srcset');
              image.src = image.dataset.small;
            } else { clear(); reject(new Error('Component image unavailable')); }
          };
          const aborted = () => { clear(); reject(new DOMException('Aborted', 'AbortError')); };
          image.addEventListener('load', loaded);
          image.addEventListener('error', failed);
          signal.addEventListener('abort', aborted, { once: true });
          image.srcset = `${image.dataset.small} 800w, ${image.dataset.src} 1600w`;
          image.src = image.dataset.small;
          // Responsive source reselection can abort decode() without a failed
          // image. Only an actual load/error result determines availability.
          if (image.complete && image.naturalWidth) loaded();
        });
      }
      cleanup() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.chromeObserver?.disconnect();
        this.stop();
      }
      disconnectedCallback() { this.cleanup(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["casa-octamirror-measurement"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('casa-octamirror-measurement')) return;
    const propertyKeys = ['_casa_pdp_version', '_casa_pdp_environment', '_casa_pdp_release'];
    const handled = new WeakSet();

    class CasaOctamirrorMeasurement extends HTMLElement {
      connectedCallback() {
        if (this.controller || this.dataset.productId !== '7417547391130') return;
        this.main = this.closest('main');
        if (!this.main) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.variants = new Set(this.dataset.variantIds.split(','));
        this.pageId ||= crypto.randomUUID();
        this.sequence ||= 0;
        const query = new URL(location.href).searchParams;
        this.dataset.pdpEnvironment = query.get('casa_pdp_qa') === '1' || query.has('preview_theme_id')
          ? 'qa'
          : this.dataset.themeId !== '152924782746' ? 'preview'
            : query.has('view') ? 'alternate' : 'live';

        document.addEventListener('visitorConsentCollected', () => this.syncConsent(), { signal });
        document.addEventListener('visibilitychange', () => this.expose(), { signal });
        window.addEventListener('pageshow', () => this.syncConsent(), { signal });
        window.addEventListener('load', () => this.initializePrivacy(), { once: true, signal });
        this.main.addEventListener('submit', () => this.syncForms(), { capture: true, signal });
        this.main.addEventListener('formdata', (event) => {
          if (!this.isProductForm(event.target)) return;
          const values = this.properties();
          propertyKeys.forEach((key) => {
            if (this.allowed()) event.formData.set(`properties[${key}]`, values[key]);
            else event.formData.delete(`properties[${key}]`);
          });
        }, { capture: true, signal });
        document.addEventListener('variant:update', (event) => {
          if (String(event.detail?.data?.productId) === this.dataset.productId) this.syncForms();
        }, { signal });
        document.addEventListener('cart:update', (event) => {
          const data = event.detail?.data;
          const variant = String(event.detail?.sourceId || '');
          if (handled.has(event) || data?.source !== 'product-form-component' || data.didError ||
              String(data.productId) !== this.dataset.productId || !this.variants.has(variant)) return;
          const quantity = Number(data.itemCount);
          if (!Number.isInteger(quantity) || quantity < 1) return;
          handled.add(event);
          this.emit('cart_success', variant, { quantity });
        }, { signal });
        this.observer = new MutationObserver((records) => {
          if (records.some((record) => [...record.addedNodes].some((node) =>
            node.nodeType === 1 && (node.matches('form, product-form-component') || node.querySelector('form'))
          ))) this.syncForms();
        });
        this.observer.observe(this.main, { childList: true, subtree: true });
        this.initializePrivacy();
      }

      allowed() {
        try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
        catch { return false; }
      }

      initializePrivacy() {
        this.syncConsent();
        if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
            if (this.isConnected) this.syncConsent();
          });
        }
      }

      isProductForm(form) {
        return form?.matches('form') &&
          form.closest('product-form-component')?.dataset.productId === this.dataset.productId &&
          this.variants.has(form.querySelector('input[name="id"]')?.value);
      }

      forms() {
        return [...this.main.querySelectorAll('product-form-component form')].filter((form) => this.isProductForm(form));
      }

      properties() {
        return {
          _casa_pdp_version: this.dataset.pdpVersion,
          _casa_pdp_environment: this.dataset.pdpEnvironment,
          _casa_pdp_release: this.dataset.pdpRelease
        };
      }

      syncForms() {
        const enabled = this.allowed();
        this.forms().forEach((form) => {
          Object.entries(this.properties()).forEach(([key, value]) => {
            let input = form.querySelector(`input[name="properties[${key}]"]`);
            if (!enabled) { input?.remove(); return; }
            if (!input) {
              input = document.createElement('input');
              input.type = 'hidden';
              input.name = `properties[${key}]`;
              input.dataset.casaOctamirrorProperty = '';
              form.append(input);
            }
            input.value = value;
          });
        });
      }

      syncConsent() {
        this.dataset.measurementStatus = this.allowed() ? 'consented' : 'consent-blocked';
        this.syncForms();
        this.expose();
      }

      expose() {
        if (this.exposed || this.exposing || document.visibilityState !== 'visible') return;
        const variant = this.forms()[0]?.querySelector('input[name="id"]')?.value;
        if (!variant) return;
        this.exposing = true;
        this.emit('view', variant).then((sent) => { this.exposed = sent; }).finally(() => { this.exposing = false; });
      }

      async emit(action, variant, extra = {}) {
        if (!this.isConnected || !this.allowed()) return false;
        const publish = window.Shopify?.analytics?.publish;
        if (typeof publish !== 'function') {
          this.dataset.measurementStatus = 'publisher-unavailable';
          return false;
        }
        const eventId = `${this.pageId}:${++this.sequence}`;
        try {
          const result = await publish.call(window.Shopify.analytics, 'casa:octamirror_pdp', {
            schema_version: 1, action,
            product_id: this.dataset.productId, variant_id: variant,
            pdp_version: this.dataset.pdpVersion, pdp_environment: this.dataset.pdpEnvironment,
            pdp_release: this.dataset.pdpRelease, theme_id: this.dataset.themeId,
            event_id: eventId, ...extra
          });
          if (result === false) throw new Error('Publisher declined');
          this.dataset.measurementStatus = 'published-to-shopify';
          this.dataset.lastAction = action;
          this.dataset.lastVariantId = variant;
          this.dataset.eventCount = String(this.sequence);
          return true;
        } catch {
          this.dataset.measurementStatus = 'publish-failed';
          return false;
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.main?.querySelectorAll('[data-casa-octamirror-property]').forEach((input) => input.remove());
      }
    }
    customElements.define('casa-octamirror-measurement', CasaOctamirrorMeasurement);
  })();
  } catch(e) { console.error(e); }
})();

})();
